import { backendServices } from '../services';
import { useQuery } from '@tanstack/react-query';
import buildQuery, { ITEM_ROOT } from 'odata-query';
import { PortalType } from '../types';

type Params = Parameters<InstanceType<typeof backendServices.Apis.RoleTypeApi>['getRoleTypes']>[0];

export function useGetRoleType({ $filter, $top, $skip, $count, $orderBy, includeAll }: Params) {
    const query = useQuery({
        queryKey: ['RoleTypes', $filter, $top, $skip, $count, $orderBy, includeAll],
        queryFn: async () => {
            const api = new backendServices.Apis.RoleTypeApi();

            const res = await api.getRoleTypes({ $filter, $top, $skip, $count, $orderBy, includeAll });

            return res.data;
        },
        cacheTime: Infinity,
        staleTime: Infinity,
    });

    return query;
}

export function createRoleTypeFilterForPortalType({
    companyId,
    portalType,
}: {
    companyId: number;
    portalType: PortalType;
}) {
    const query = buildQuery({
        filter: {
            or: {
                and: [
                    {
                        PortalType: {
                            or: [
                                { [ITEM_ROOT]: portalType },
                                { [ITEM_ROOT]: PortalType.TransceptaManagerAndSupplierPortal },
                            ],
                        },
                    },
                    {
                        CompanyID: { eq: null },
                    },
                ],
                CompanyID: { eq: companyId },
            },
        },
    });

    return query.replace('?$filter=', '');
}
